import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './LaoDongNongNghiep.css';
import './Home.css';
import logo from './logo.png';

// Icon components
const LeafIcon: React.FC<{ size?: number; color?: string }> = ({ size = 36, color = '#F57C00' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Leaf">
    <g fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 3c5.5 2.5 5.5 16.5 0 19" fill={color} opacity=".15" />
      <path d="M6 3c5.5 2.5 5.5 16.5 0 19" />
      <path d="M6 3c-2.5 5.5-2.5 10.5 0 19" />
    </g>
  </svg>
);

const WaterIcon: React.FC<{ size?: number; color?: string }> = ({ size = 36, color = '#F57C00' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Water">
    <g fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill={color} opacity=".15" />
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
    </g>
  </svg>
);

const WarningIcon: React.FC<{ size?: number; color?: string }> = ({ size = 36, color = '#F57C00' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Warning">
    <g fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" fill={color} opacity=".15" />
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </g>
  </svg>
);

const FlowerIcon: React.FC<{ size?: number; color?: string }> = ({ size = 36, color = '#F57C00' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Flower">
    <g fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3" fill={color} opacity=".15" />
      <circle cx="12" cy="12" r="3" />
      <path d="M12 1v6m0 6v6M1 12h6m6 0h6" />
      <path d="M12 1c-2.5 2.5-2.5 6.5 0 9s6.5 2.5 9 0 2.5-6.5 0-9-6.5-2.5-9 0z" />
    </g>
  </svg>
);

const BasketIcon: React.FC<{ size?: number; color?: string }> = ({ size = 36, color = '#F57C00' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Basket">
    <g fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-6" fill={color} opacity=".15" />
      <path d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-6" />
    </g>
  </svg>
);

const CutIcon: React.FC<{ size?: number; color?: string }> = ({ size = 36, color = '#F57C00' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Cut">
    <g fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="6" cy="6" r="3" fill={color} opacity=".15" />
      <circle cx="6" cy="6" r="3" />
      <circle cx="18" cy="18" r="3" fill={color} opacity=".15" />
      <circle cx="18" cy="18" r="3" />
      <line x1="6" y1="18" x2="18" y2="6" />
      <path d="M6 6l12 12" />
    </g>
  </svg>
);

const LaoDongNongNghiep: React.FC = () => {
	const navigate = useNavigate();
	const [navOpen, setNavOpen] = React.useState(false);
	React.useEffect(() => {
		document.title = 'Lao động nông nghiệp - Fconnect';
	}, []);

	return (
		<div className="home-page">
			{/* Header (reuse from Home) */}
			<header className="home-header">
				<div className="home-container header-inner">
					<div className="brand" onClick={() => { navigate('/'); setNavOpen(false); }}>
						<img src={logo} alt="Fconnect" />
					</div>
					<button
						className="nav-toggle"
						aria-label={navOpen ? 'Đóng menu' : 'Mở menu'}
						aria-expanded={navOpen}
						aria-controls="main-navigation"
						onClick={() => setNavOpen((o) => !o)}
					>
						{navOpen ? '✕' : '☰'}
					</button>
					<nav id="main-navigation" className={`main-nav ${navOpen ? 'open' : ''}`}>
						<Link to="/" onClick={() => setNavOpen(false)}>Trang chủ</Link>
						<Link to="/lao-dong-pho-thong" onClick={() => setNavOpen(false)}>Lao động phổ thông</Link>
						<Link to="/lao-dong-nong-nghiep" onClick={() => setNavOpen(false)}>Lao động nông nghiệp</Link>
						<Link to="/dich-vu-y-te" onClick={() => setNavOpen(false)}>Dịch vụ y tế</Link>
						<Link to="/privacy" onClick={() => setNavOpen(false)}>Chính sách bảo mật</Link>
						<Link to="/terms" onClick={() => setNavOpen(false)}>Điều khoản</Link>
						<Link to="/contact" onClick={() => setNavOpen(false)}>Liên hệ</Link>
						<Link to="/en" className="lang-link" onClick={() => setNavOpen(false)}>English</Link>
					</nav>
				</div>
			</header>
			<div className={`nav-backdrop ${navOpen ? 'open' : ''}`} onClick={() => setNavOpen(false)} />

			{/* Banner Section */}
			<section className="ldt-banner-section">
				<div className="ldt-banner-content">
					<div className="ldt-banner-text">
						<h2>Dịch vụ lao động nông nghiệp chuyên nghiệp</h2>
						<p>Chăm sóc vườn tược, cây trồng và nông sản với kỹ thuật hiện đại</p>
					</div>
					<div className="ldt-banner-visual">
						<div className="ldt-banner-icons">
							<LeafIcon size={48} color="#F57C00" />
							<WaterIcon size={48} color="#F57C00" />
							<FlowerIcon size={48} color="#F57C00" />
							<BasketIcon size={48} color="#F57C00" />
						</div>
					</div>
				</div>
			</section>

			{/* Content */}
			<section className="home-container">
				<header className="ldt-hero">
					<h1>Lao động nông nghiệp</h1>
					<p className="ldt-subtitle">Chuyên nghiệp, uy tín, chất lượng cao trong lĩnh vực nông nghiệp và chăm sóc cây trồng.</p>
				</header>

				<div className="ldt-content">
					<section className="ldt-section">
						<h2 className="section-title">Các dịch vụ</h2>
						<div className="services-grid">
							<div className="service-card">
								<div className="service-icon"><LeafIcon size={56} /></div>
								<h4>Cắt cỏ</h4>
								<p>Dọn dẹp cỏ dại, tạo cảnh quan sạch sẽ cho vườn tược và khuôn viên.</p>
							</div>
							<div className="service-card">
								<div className="service-icon"><WaterIcon size={56} /></div>
								<h4>Bón phân</h4>
								<p>Bón phân đúng cách, đúng liều lượng để cây trồng phát triển tốt nhất.</p>
							</div>
							<div className="service-card">
								<div className="service-icon"><WarningIcon size={56} /></div>
								<h4>Xịt thuốc</h4>
								<p>Phun thuốc bảo vệ thực vật an toàn, hiệu quả theo đúng quy trình.</p>
							</div>
							<div className="service-card">
								<div className="service-icon"><FlowerIcon size={56} /></div>
								<h4>Trồng trọt</h4>
								<p>Gieo trồng, chăm sóc cây con, tạo môi trường phát triển tối ưu.</p>
							</div>
							<div className="service-card">
								<div className="service-icon"><BasketIcon size={56} /></div>
								<h4>Thu hoạch</h4>
								<p>Thu hoạch nông sản đúng thời điểm, đảm bảo chất lượng và năng suất.</p>
							</div>
							<div className="service-card">
								<div className="service-icon"><CutIcon size={56} /></div>
								<h4>Chăm sóc vườn</h4>
								<p>Tổng thể chăm sóc vườn tược, cắt tỉa, tạo hình cây trồng đẹp mắt.</p>
							</div>
						</div>
					</section>

					<section className="ldt-section">
						<h2 className="section-title">Gói dịch vụ theo giờ</h2>
						<div className="packages-grid">
							<div className="package-card">
								<div className="package-header">
									<h3>Gói 2 giờ</h3>
									<p className="package-sub">Phù hợp công việc gọn nhẹ</p>
								</div>
								<ul className="package-list">
									<li>Cắt cỏ khu vực nhỏ</li>
									<li>Bón phân cơ bản</li>
									<li>Kiểm tra sức khỏe cây</li>
								</ul>
							</div>

							<div className="package-card">
								<div className="package-header">
									<h3>Gói 3 giờ</h3>
									<p className="package-sub">Xử lý trọn vẹn một đầu việc</p>
								</div>
								<ul className="package-list">
									<li>Chăm sóc vườn chi tiết</li>
									<li>Bón phân và tưới nước</li>
									<li>Cắt tỉa cây trồng</li>
								</ul>
							</div>

							<div className="package-card">
								<div className="package-header">
									<h3>Gói 4 giờ</h3>
									<p className="package-sub">Nhiều hạng mục trong một lần</p>
								</div>
								<ul className="package-list">
									<li>Dọn dẹp toàn bộ vườn</li>
									<li>Bón phân và xịt thuốc</li>
									<li>Trồng mới và chăm sóc</li>
								</ul>
							</div>

							<div className="package-card">
								<div className="package-header">
									<h3>Gói một ngày</h3>
									<p className="package-sub">Phục vụ trọn ngày cho nhu cầu lớn</p>
								</div>
								<ul className="package-list">
									<li>Chăm sóc vườn toàn diện</li>
									<li>Trồng mới và bảo trì</li>
									<li>Thu hoạch và dọn dẹp</li>
								</ul>
							</div>
						</div>
					</section>
				</div>
			</section>

			{/* Footer (reuse from Home) */}
			<footer className="home-footer">
				<div className="home-container footer-inner">
					<div className="footer-contact">
						<p><strong>CÔNG TY CỔ PHẦN TÀI CHÍNH HIỆP TÍN PHÁT</strong></p>
						<p><strong>Email:</strong> trile@fconnect.vn</p>
						<p><strong>Điện thoại:</strong> 02513684266</p>
						<p><strong>Địa chỉ:</strong> 11/4C, tổ 15, Kp 6, đường Nguyễn Ái Quốc, Phường Trấn Biên, Tp. Đồng Nai, Việt Nam</p>
						<p><strong>Thời gian hỗ trợ:</strong> 8:00 - 22:00 (Thứ 2 - Chủ nhật)</p>
					</div>
					<div className="footer-stores">
						<a className="store-badge small appstore-badge" href="https://apps.apple.com/vn/app/fconnect-htp/id6752923786?l=vi" target="_blank" rel="noopener noreferrer">
							<span className="badge-icon" aria-hidden="true"></span>
							<span className="badge-text"><span className="badge-sub">Download on the</span><span className="badge-brand">App Store</span></span>
						</a>
						<a className="store-badge small play-badge" href="https://play.google.com/store/apps/details?id=com.taichinhhtp.fconnect&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
							<span className="badge-icon" aria-hidden="true">▶</span>
							<span className="badge-text"><span className="badge-sub">GET IT ON</span><span className="badge-brand">Google Play</span></span>
						</a>
					</div>
				</div>
				<div className="copyright">© 2025 Fconnect. Tất cả các quyền được bảo lưu.</div>
			</footer>
		</div>
	);
};

export default LaoDongNongNghiep;
